import Vue from 'vue'
import { get } from 'lodash'

const debug = false

export default ({ bus, appCache }) => {
  // Share components
  const shared = require.context('./Components/Shared', true, /\.(vue)$/i)
  shared.keys().map(key => Vue.component(key.substr(key.lastIndexOf('/') + 1).replace('.vue', ''), shared(key).default))

  // Require components
  const requiredComponents = {}
  const required = require.context('./Components/Required', true, /\.(vue)$/i)
  required.keys().map(key => {
    const name = key.substr(key.lastIndexOf('/') + 1).replace('.vue', '')
    Vue.component(name, required(key).default)
    requiredComponents[name] = required(key).default
  })

  return new Vue({
    data () {
      return {
        app: {
          version: appCache.version,
          updating: false
        },
        layout: 'main',
        requiredComponents: requiredComponents,
        key: Math.random().toString(36).substr(2, 5),
        loader: {
          api: 0,
          storage: 0,
        },
        navigation: {
          visible: null,
        },
        language: null
      }
    },
    computed: {
      isLoading () {
        let total = 0
        Object.values(this.loader).forEach(count => {
          total += count
        })
        return total > 0
      }
    },
    methods: {
      component (name, component) {
        Vue.component(name, component)
        this.requiredComponents[name] = component
      },

      async checkForUpdate ({ reloadIfNoWOrker } = {}) {
        if ('serviceWorker' in navigator) {
          const reg = await navigator.serviceWorker.getRegistration('/service-worker.js')
          if (reg) await reg.update()
        } else {
          if (reloadIfNoWOrker) {
            window.location.reload(true)
          } else {
            this.notifyUpdateFound()
          }
        }
      },
      notifyDownloadingUpdate () {
        bus.emit('ui/notification', { name: 'downloadingUpdate', action: 'open' })
      },
      notifyUpdateFound () {
        this.closeNotifications()
        bus.emit('ui/notification', { name: 'updateFound', action: 'open' })
      },
      closeNotifications () {
        bus.emit('ui/notification', { name: '*', action: 'close' })
      },

      openDialog (name, payload) {
        bus.emit('dialog/' + name + '/open', payload)
      },
      openUserNotifications () {
        bus.emit('notifications/open')
      },

      info (text, modal = false) {
        bus.emit('ui/message', { type: 'info', modal, text })
      },
      iinfo (itext, modal = false) {
        bus.emit('ui/message', { type: 'info', modal, itext })
      },
      success (text, modal = false) {
        bus.emit('ui/message', { type: 'success', modal, text })
      },
      isuccess (itext, modal = false) {
        bus.emit('ui/message', { type: 'success', modal, itext })
      },
      warning (text, modal = false) {
        bus.emit('ui/message', { type: 'warning', modal, text })
      },
      iwarning (itext, modal = false) {
        bus.emit('ui/message', { type: 'warning', modal, itext })
      },
      error (text = null, modal = false) {
        if (text) {
          bus.emit('ui/message', { type: 'error', modal, text })
        } else {
          bus.emit('ui/message', { type: 'error', modal, itext: 'messages.unknown-error-occured' })
        }
      },
      ierror (itext, modal = false) {
        bus.emit('ui/message', { type: 'error', modal, itext })
      },

      routerBeforeEach (to, from, next) {
        if (debug) console.log('[ui] Guard: moving to ' + to.path)
        this.layout = get(to, 'meta.ui.layout', 'main')
        if (debug) console.log('[ui] Setting layout', this.layout)
        next()
      }
    },
    created () {
      bus.on('ui/loading', ({ name, count }) => {
        this.$set(this.loader, name, count)
      })

      bus.on('refresh', ({ ui } = {}) => {
        if (ui !== false) {
          this.key = Math.random().toString(36).substr(2, 5)
        }
      })
    }
  })
}